import { Heading } from "../../../../components/common/typography";
import { CurrencyAmount } from "../../../../components/common/currency_amount";

interface ProductHeaderProps {
  productName: string;
  price: number;
}

export function ProductHeader({ productName, price }: ProductHeaderProps) {
  return (
    <>
      {/* Product Title */}
      <div>
        <Heading variant="h1" tone="dark" className="mb-2">
          {productName || "—"}
        </Heading>
      </div>

      {/* Price */}
      <div>
        <CurrencyAmount amount={price} variant="h2" tone="dark" />
      </div>
    </>
  );
}
